export default __webpack_public_path__ + "components/card-two-column/card-two-column.html.twig";